import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

import { TrackingApi } from 'api/TrackingApi';
import { useXRefererUrl } from 'hooks/useXRefererUrl';

import { FullscreenSpinner } from 'components/shared/FullscreenSpinner';

import { TDSEntryPage } from 'pages/TDSPages/TDSEntryPage';

const TDSClickPage = loadable(
  () =>
    import(
      /* webpackChunkName: "TDSClickPage" */ 'pages/TDSPages/TDSClickPage'
    ),
  {
    resolveComponent: (component) => component.TDSClickPage,
    fallback: <FullscreenSpinner />,
  }
);

export const TDSApp = () => {
  useXRefererUrl();

  useEffect(() => {
    TrackingApi.trackTdsLoadEnd();
  }, []);

  return (
    <Switch>
      <Route path="/entry/click" component={TDSClickPage} />
      <Route path="/entry" component={TDSEntryPage} />
    </Switch>
  );
};
